<template>
  <div id="app">
    <router-view/>
    <div class="fd-enabled" style="position: fixed;bottom: 0;left: 0;width: 100%;z-index: 2001;background-color: rgba(17, 17, 17, 0.7);line-height: 24px;color: #eeeeee;text-align: center;padding: 3px 0;">
      We use cookies to track usage and preferences
      <span style="background: hsl(225, 52%, 27%);display: inline-block;border-radius: 3px;text-decoration: none;padding: 0 6px;cursor: pointer;" @click="understand">I Understand</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted () {
    if (localStorage.getItem('cb-enabled')) {
      document.querySelector('.fd-enabled').style.display = 'none';
    }
  },
  methods: {
    understand () {
      document.querySelector('.fd-enabled').style.display = 'none';
      localStorage.setItem('cb-enabled', 'true');
    }
  },
}
</script>

<style lang='less'>
@import "./css/index.less";
</style>



// WEBPACK FOOTER //
// src/App.vue